// extracted by css-extract-rspack-plugin
module.exports =  {"cards":"StudentCards-sP9z__cards"};